import { render, staticRenderFns } from "./ceping-edit.vue?vue&type=template&id=b93ac32e&scoped=true&"
import script from "./ceping-edit.vue?vue&type=script&lang=ts&"
export * from "./ceping-edit.vue?vue&type=script&lang=ts&"
import style0 from "./ceping-edit.vue?vue&type=style&index=0&id=b93ac32e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93ac32e",
  null
  
)

export default component.exports